import { render, staticRenderFns } from "./Solicitados.vue?vue&type=template&id=9311e48e&scoped=true&"
import script from "./Solicitados.vue?vue&type=script&lang=js&"
export * from "./Solicitados.vue?vue&type=script&lang=js&"
import style0 from "./Solicitados.vue?vue&type=style&index=0&id=9311e48e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9311e48e",
  null
  
)

export default component.exports